import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { LayoutActions } from "../actions/types/layout";

export const useLayoutDispatch = (): Dispatch<LayoutActions> => useDispatch();
